// frontend/src/config/rolePermissions.js
// Miroir des permissions seedées côté backend (migrations 09 & 27).
// Sert UNIQUEMENT à filtrer l'UI (menu, écrans). La sécurité réelle reste backend.

// Rôles staff OFFICIELS de company.gowele.com (assignables par un admin compagnie).
// FINANCE_AGENT / SUPPORT_AGENT supprimés (fondus dans Chef d'agence / Agent de gare).
// DRIVER n'a jamais accès à company.gowele.com (espace dédié : driver.gowele.com).
export const STAFF_ROLES = [
  'CHEF_AGENCE', 'RESERVATION_AGENT', 'TRAFFIC_AGENT',
];

// Rôles staff encore reconnus pour la connexion (comptes existants) mais NON assignables.
export const LEGACY_STAFF_ROLES = ['FINANCE_AGENT', 'SUPPORT_AGENT', 'OPERATOR'];

export const ROLE_LABELS = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN_COMPANY: 'Admin compagnie',
  CHEF_AGENCE: "Chef d'agence",
  RESERVATION_AGENT: 'Agent de gare',
  TRAFFIC_AGENT: 'Responsable exploitation',
  FINANCE_AGENT: 'Agent finance',
  SUPPORT_AGENT: 'Agent support client',
  OPERATOR: 'Opérateur',
  DRIVER: 'Chauffeur',
  CLIENT: 'Passager',
};

export const ROLE_PERMISSIONS = {
  SUPER_ADMIN: ['all'],
  ADMIN_COMPANY: ['all'], // tout dans le périmètre de sa compagnie (scope backend)

  // 🏬 CHEF D'AGENCE — pilote SON agence : équipe + ventes guichet + relation client + rapports/GPS agence.
  // (⚠️ MIROIR EXACT de backend/services/ensureRolePermissions.js (table role_permissions),
  //  sinon un menu s'afficherait mais l'API répondrait 403.)
  CHEF_AGENCE: [
    'manage_agence', 'manage_agence_agents', 'view_agence_reports', 'manage_local_sales',
    'create_reservation', 'update_reservation', 'cancel_reservation', 'print_ticket', 'send_ticket',
    'manage_clients', 'manage_messages', 'manage_complaints',
    'view_gps',
  ],

  // 🎫 AGENT DE GARE — guichet (réservations/billets) + relation client. Aucun accès réseau/finance.
  RESERVATION_AGENT: [
    'create_reservation', 'update_reservation', 'cancel_reservation', 'print_ticket', 'send_ticket',
    'manage_clients', 'manage_messages', 'manage_complaints',
  ],

  // 🚌 RESPONSABLE EXPLOITATION — réseau : trajets/arrêts/bus/chauffeurs/GPS. Aucune finance ni réservation.
  TRAFFIC_AGENT: [
    'create_trajet', 'update_trajet', 'assign_bus', 'assign_driver', 'manage_arrets', 'view_gps',
  ],

  // ── Rôles legacy (comptes existants) — non assignables, périmètre minimal ──
  FINANCE_AGENT: ['financial_reports', 'manage_payments', 'manage_refunds'],
  SUPPORT_AGENT: ['manage_clients', 'manage_complaints', 'manage_messages'],
  OPERATOR: ['create_reservation', 'create_trajet', 'manage_arrets'],

  DRIVER: [],   // jamais d'accès company.gowele.com
  CLIENT: [],
};

// Permissions effectives d'un ensemble de rôles.
export const permissionsForRoles = (roles = []) => {
  const set = new Set();
  roles.forEach((r) => (ROLE_PERMISSIONS[r] || []).forEach((p) => set.add(p)));
  return set;
};

// L'utilisateur a-t-il la permission (ou le wildcard 'all') ?
export const hasPermission = (roles = [], permission) => {
  const set = permissionsForRoles(roles);
  return set.has('all') || set.has(permission);
};